/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EmailV2 {
  id?: number;
  to?: string | null;
  cc?: string | null;
  bcc?: string | null;
  subject?: string | null;
  message?: string | null;
  attachments?: string | null;
  imageToUse?: string | null;
  emailTitle?: string | null;
  processed?: boolean | null;
  processedAt?: string | null;
  language?: string | null;
}
